import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NewPromotionProfileDTO, PromotionId, PromotionProfile } from '@portal-front-end/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })

export class PromotionProfileApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly PROMOTION_PROFILE_URL = `${this.apiServer}/promotion-profiles`;

    getPromotionProfiles(orgId: string): Observable<PromotionProfile[]> {
        return this.http.get<PromotionProfile[]>(`${this.PROMOTION_PROFILE_URL}/search`, {
            params: { 'organisationId': orgId }
        });
    }

    createPromotionProfile(entity: NewPromotionProfileDTO): Observable<PromotionProfile> {
        return this.http.post<PromotionProfile>(`${this.PROMOTION_PROFILE_URL}/${entity.promotionId}`, {
            "profileIdList": entity.profileId
        });
    }

    deletePromotionProfile(id: string): Observable<string | number> {
        let params = id.split('+');
        return this.http.delete<string | number>(`${this.PROMOTION_PROFILE_URL}/${params[0]}/${params[1]}`)
            .pipe(map(() => id));
    }
}
